/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';

export const FlexContainer = styled.default.div`
  display: flex;
  flex-wrap: wrap;
`;

export const WideFlexContainer = styled.default.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const FormInputWrapper = styled.default.div`
    margin: 0 1rem 1rem 0;
  `;